module.exports = __webpack_public_path__ + "assets/img/Blackpurl-Landing-Page.98ac4e63.webp";